import { useMatchRules, useTournamentView } from '@/features/standings/useTournamentView';
import { useMatches } from '@/features/matches/useMatches';
import { useMyTeam } from '@/features/team/useMyTeam';
import { useTeamLookup, useTeams } from '@/features/team/useTeams';

import { useTournament } from './useTournament';

/**
 * Single entry point for every view that shows tournament data.
 *
 * The three subscriptions (tournament, teams, matches) are shared through the
 * query cache, so mounting this hook in several components does not open
 * several listeners.
 */
export function useTournamentData() {
  const tournament = useTournament();
  const teams = useTeams();
  const matches = useMatches();
  const myTeam = useMyTeam();

  const lookup = useTeamLookup(teams.data);
  const view = useTournamentView(tournament.data, teams.data, matches.data);
  const rulesFor = useMatchRules(tournament.data);

  const firstError = tournament.error ?? teams.error ?? matches.error;

  return {
    tournament: tournament.data,
    teams: teams.data ?? [],
    matches: matches.data ?? [],
    myTeam: myTeam.data ?? null,
    lookup,
    rulesFor,
    phases: view.phases,
    isLoading: tournament.isLoading || teams.isLoading || matches.isLoading,
    // Exposed separately so the admin area can offer "Turnier anlegen" when
    // the document is missing, instead of dead-ending on the generic
    // "Turnier nicht verfügbar" screen.
    tournamentError: tournament.error,
    errorMessage: firstError?.message ?? view.error,
  };
}
